import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  title: "",
  short_description: "",
  description: "",
  price: "",
  is_free: 0,
  currency: "USD",
  category_slug: "",
  condition_slug: "",
  
  university_only: 0,
  seller_notes: "",
  media: [],
  locationId: 0,
  formattedAddress: "",
};

export const createMarketplaceSlice = () => {
  const sellingDataSlice = createSlice({
    name: "sellingData",
    initialState,
    reducers: {
      setSellingData: (state, action) => {
        return { ...state, ...action.payload };
      },
      
      resetSellingData: () => initialState,
    },
  });
   

  return sellingDataSlice;
};

// Export actions for use in components
const marketplaceSlice = createMarketplaceSlice();
export const { setSellingData, resetSellingData } = marketplaceSlice.actions;
